module.exports = __webpack_public_path__ + "img/861-409916.png";